import React from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        <div className="delete-modal-header">
          <h2>Confirm Deletion</h2>
          <button className="delete-modal-close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="delete-modal-body">
          <p>{message}</p>
        </div>
        {/* Cancel first, as in ConfirmModal: on a dialog whose other button destroys something,
            the safe answer is the one the eye and a stray Return key land on. */}
        <div className="btn-row">
          <button className="btn btn--secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn--danger" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;